import { combineReducers } from 'redux';
import CustomizerReducer from './customizer/CustomizerReducer';
import {ModalReducer} from "./modals.reducer";
const RootReducers = combineReducers({
  CustomizerReducer,
  ModalReducer
});

export default RootReducers;
